package com.partejar.app.core.navigation

object AppRoutes {
    const val AUTH = "auth_screen"
    const val HOME = "home_screen"
    const val SPLASH = "splash_screen"
    const val WORKSPACE_SELECTION = "workspace_selection"
    const val FIRST_WORKSPACE = "first_workspace"
    const val PROFILE = "profile"
    const val SETTINGS = "settings"
    const val ACCOUNT_DELETION = "account_deletion"
    const val ACCOUNT_DELETION_CONFIRMATION = "account_deletion_confirmation"
    const val TEAM = "team"
    const val PLANS = "plans"
    const val CREATE_PLAN = "plans/create"
    const val CONTRACT_TEMPLATES = "contract_templates"
    const val CREATE_CONTRACT_TEMPLATE = "contract_templates/create"
    const val CONTRACT = "contract"
    const val CALENDAR = "calendar"
    const val AGENDA = "agenda"
    const val GESTANTES = "gestantes"
    const val GESTANTE_DETAIL = "gestante_detail"
    const val GESTANTE_PATIENT_ID_ARGUMENT = "patientId"
    const val GESTANTE_COMORBIDITIES = "gestante_comorbidities/{$GESTANTE_PATIENT_ID_ARGUMENT}"
    const val GESTANTE_EXAMS = "gestante_exams/{$GESTANTE_PATIENT_ID_ARGUMENT}"
    const val RELACIONAMENTOS = "relacionamentos"
    const val RELACIONAMENTO_DETAIL = "relacionamento_detail"
    const val RELACIONAMENTO_EDIT = "relacionamento_edit"
    const val RELACIONAMENTO_NEW = "relacionamento_new"
    const val WORKSPACES = "workspaces"
    const val CREATE_WORKSPACE = "workspace_create"
    const val EDIT_WORKSPACE = "workspace_edit"
    const val INVITE = "invite"
    const val AUTH_INVITE = "auth_invite"

    fun gestanteComorbidities(patientId: Long): String = "gestante_comorbidities/$patientId"

    fun gestanteExams(patientId: Long): String = "gestante_exams/$patientId"
}
